import { useService } from '@toeverything/infra';
import { createContext, useCallback, useContext } from 'react';

import type { SettingTab } from './constant';
import { WorkspaceDialogService } from './services/workspace-dialog';

export type OpenSettingTab = (
  tab: SettingTab,
  anchor?: string,
  subjectId?: string
) => void;

/** Provided by an open settings dialog, so links inside it change the page in place. */
export const SettingTabNavigationContext = createContext<OpenSettingTab | null>(
  null
);

/**
 * Opens a settings page. Inside the settings dialog the open dialog changes its
 * page; everywhere else the dialog opens on that page.
 */
export function useOpenSettingTab(): OpenSettingTab {
  const changePage = useContext(SettingTabNavigationContext);
  const dialogs = useService(WorkspaceDialogService);
  const openDialog = useCallback<OpenSettingTab>(
    (activeTab, scrollAnchor, subjectId) => {
      dialogs.open('setting', { activeTab, scrollAnchor, subjectId });
    },
    [dialogs]
  );
  return changePage ?? openDialog;
}
